module.exports = __webpack_public_path__ + "img/koda_logo_843x843.64de3574.png";